module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Bucket-c2bbb20219ddf86114e4be298f96a32d.svg";